import firebase from './firebase'
import type { Pomodoro } from './types'

const db = firebase.database()

const refForUser = (userId: string): string => `users/${userId}/pomodoros`

export const writePomodoro = (
  userId: string,
  pomodoroTime: number,
  summary?: string,
  type: 'TIMER' | 'MANUAL' = 'TIMER',
  standingDesk?: boolean,
  walkingPad?: boolean
): void => {
  const existingPomodoros = db.ref(refForUser(userId))

  const newPomodoro = existingPomodoros.push()
  const date = [
    new Date().getFullYear(),
    new Date().getMonth() + 1,
    new Date().getDate(),
  ].join('-')

  const data: Pomodoro = {
    timeFinished: Date.now(),
    date,
    length: pomodoroTime,
    type,
    ...(summary && { summary }),
    ...(standingDesk && { standingDesk: true }),
    ...(walkingPad && { walkingPad: true }),
  }
  newPomodoro?.set(data)
}

export const allPomodorosForUser = (
  userId: string,
  cb: (data: Map<string, Pomodoro>) => void
): void => {
  db.ref(refForUser(userId)).on('value', (snapshot) => {
    if (!snapshot || !snapshot.val()) {
      cb(new Map())
      return
    }

    const data = snapshot.val() as Record<string, Pomodoro>
    const mapOfData = new Map<string, Pomodoro>()

    Object.keys(data).forEach((key) => {
      const pomodoro = data[key]
      if (pomodoro) {
        mapOfData.set(key, pomodoro)
      }
    })
    cb(mapOfData)
  })
}

export const clearDBEventListeners = (userId: string): void => {
  db.ref(refForUser(userId)).off()
}
